import type { ReactNode } from 'react';

export const InfoBlockWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="h-min w-full p-4 border border-e3 rounded-md">
      {children}
    </div>
  );
};
